import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  listGroup,
  listGroupIdByStaff,
  listGroupIdByUser,
} from "./thunkAction";

const initialState = {
  groups: [],
  groupIds: [],
  groupStaff: [],
  loading: false,
  error: null,
};

const groupSlice = createSlice({
  name: "groupManage",
  initialState,
  reducers: {
    clearStaff(state) {
      state.groups = [];
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // listGroup
      .addCase(listGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(listGroup.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.groups = _.get(action, "payload", []);
      })
      .addCase(listGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // listGroupIdByUser
      .addCase(listGroupIdByUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(listGroupIdByUser.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.groupIds = _.get(action, "payload", []);
      })
      .addCase(listGroupIdByUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // listGroupIdByStaff
      .addCase(listGroupIdByStaff.pending, (state) => {
        state.loading = true;
      })
      .addCase(listGroupIdByStaff.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        const groupStaff = _.get(action, "payload", {});
        const staffId = _.get(groupStaff, "staffId");
        const groupIds = _.get(groupStaff, "groupIds", []);

        if (staffId) {
          state.groupStaff[staffId] = groupIds;
        }
      })
      .addCase(listGroupIdByStaff.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const groupReducer = groupSlice.reducer;

export const groupAction = groupSlice.actions;
